import { cn } from '@/lib/utils'
import { PropsWithChildren } from 'react'
import { useTheme } from '@/components/theme-provider'
import { useCustomDomain } from '../hooks/useCustomDomain'
import SeoHead from './SeoHead'
import { SeoValues, siteTitle } from '../helpers/seo'

type MainProps = PropsWithChildren<
  SeoValues & {
    fullWidth?: boolean
  }
>

const Main = ({
  fullWidth,
  title,
  description,
  robots,
  ogType,
  ogImage,
  siteName,
  children,
}: MainProps) => {
  const { currentScheme } = useTheme()
  const { customDomain } = useCustomDomain()

  const backgroundImage =
    currentScheme === 'dark'
      ? customDomain?.darkModeBodyBackgroundPath
      : customDomain?.lightModeBodyBackgroundPath

  return (
    <main
      className='min-w-0 flex-1'
      style={{
        backgroundImage: backgroundImage
          ? `url(${backgroundImage})`
          : undefined,
      }}
    >
      <SeoHead
        title={title ? siteTitle([title], customDomain) : undefined}
        description={description}
        robots={robots}
        ogType={ogType}
        ogImage={ogImage}
        siteName={siteName}
      />
      <div className={cn('min-w-0 mt-8 pb-10', fullWidth ? '' : 'root-width')}>
        {children}
      </div>
    </main>
  )
}

export default Main
